export const containerTypeGroupTerms: Record<string, string> = {
  '22GP': 'container_type-22GP',
  '42GP': 'container_type-42GP',
  '45GP': 'container_type-45GP',
  L5GP: 'container_type-L5GP',
  '22RT': 'container_type-22RT',
  '42RC': 'container_type-42RC',
}
